import { useEffect, useState } from "react";
import api from "../../services/api";

export default function useKnowledgePage({ url, collection, open, status }) {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [records, setRecords] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => { setSearch(""); setPage(1); setRecords([]); setCount(0); }, [url]);
  useEffect(() => {
    if (!open || !url) return undefined;
    let active = true;
    setLoading(true);
    setError(false);
    const timer = setTimeout(() => {
      api.get(url, { params: { searchParam: search, pageNumber: page, pageSize: 20, status } })
        .then(({ data }) => {
          if (!active) return;
          setRecords(data[collection] || []);
          setCount(Number(data.count || 0));
        })
        .catch(() => active && setError(true))
        .finally(() => active && setLoading(false));
    }, 200);
    return () => { active = false; clearTimeout(timer); };
  }, [url, collection, open, status, search, page, retry]);
  return { records, count, page, loading, error, search, setPage,
    searchFor: value => { setSearch(value); setPage(1); }, retry: () => setRetry(value => value + 1) };
}
